import React from "react";
import { ArrowLeft } from "react-feather";
const Guides = () => {
  return (
    <div className="mt-16 px-32">
       <a href="/#"
        className="mb-3 focus:outline-none -ml-3 backButtton flex hover:bg-blue-200 items-center px-4 py-2 rounded-md text-blue-700"
        style={{width:"fit-content"}}
      >
        <ArrowLeft size="16" className="mr-2" />
        <span className="text-sm">Back to Help Center</span>
      </a>
      <h1 className="text-3xl font-bold">Reference Guide</h1>
      <div className="my-16 text-gray-600">
        <div className="grid grid-cols-1 guides md:grid-cols-2">
          <div className="mb-20">
            <h3 className="font-medium text-2xl text-gray-800 mb-4">
            Configurations & Settings
            </h3>
            <a
            target="_blank"
            rel="noopener noreferrer"
              href="https://onebillknowledgehub.helpdocsonline.com/business-profile/"
              className="mb-2 block font-semibold font-semibold text-sm text-indigo-700"
            >
             Setting up business profile
            </a>
            <a 
            target="_blank"
            rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/custom-invoice-template/" className="mb-2 block font-semibold text-sm text-indigo-700">
            Customizing invoice template
            </a>
            <a 
            target="_blank"
            rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/subscriber-registration-from-selfcare/" className="mb-2 block font-semibold text-sm text-indigo-700">
            Configuring selfcare
            </a>
            <a 
             target="_blank"
             rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/configuring-alerts/" className="mb-2 block font-semibold text-sm text-indigo-700">
            Enabling alerts
            </a>
          </div>
          <div className="mb-20">
            <h3 className="font-medium text-2xl text-gray-800 mb-4">
            Products
            </h3>
            <a 
             target="_blank"
             rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/products/" className="mb-2 block font-semibold text-sm text-indigo-700">
            Product in OneBill
            </a>
            <a 
             target="_blank"
             rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/bill-time-charges/" className="mb-2 block font-semibold text-sm text-indigo-700">
            Setting up a one-time charge product

            </a>
            <a 
             target="_blank"
             rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/define-recurring-fee/" className="mb-2 block font-semibold text-sm text-indigo-700">
              Setting up a recurring charge product
            </a>
            <a 
             target="_blank"
             rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/discounts/" className="mb-2 block font-semibold text-sm text-indigo-700">
            Setting up a product with discount
            </a>
          </div>
          <div className="mb-20">
            <h3 className="font-medium text-2xl text-gray-800 mb-4">
            Subscribers
            </h3>
            <a 
             target="_blank"
             rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/subscriber-import/" className="mb-2 block font-semibold text-sm text-indigo-700">
            Subscriber in OneBill
            </a>
            <a 
             target="_blank"
             rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/new_subscriber/" className="mb-2 block font-semibold text-sm text-indigo-700">
            Creating a subscriber account
            </a>
            <a 
             target="_blank"
             rel="noopener noreferrer"
            href="https://onebillknowledgehub.helpdocsonline.com/setting-up-a-payment-profile-in-selfcare/" className="mb-2 block font-semibold text-sm text-indigo-700">
            Creating a subscriber with a payment profile
            </a>
          </div>

          {/* <div className="mb-20">
            <h3 className="font-medium text-2xl text-gray-800 mb-4">
              Payments
            </h3>
            <a href="#" className="mb-2 block font-semibold text-sm text-indigo-700">
              Subscriptions
            </a>
            <a href="#" className="mb-2 block font-semibold text-sm text-indigo-700">
              Discounts
            </a>
            <a href="#" className="mb-2 block font-semibold text-sm text-indigo-700">
              Payment methods
            </a>
            <a href="#" className="mb-2 block font-semibold text-sm text-indigo-700">
              Overdue payments
            </a>
          </div> */}

        </div>
      </div>
    </div>
  );
};

export default Guides;
